import { mapFieldArrToObjSchema } from "hooks/useDValidation";

const tagsForm = [
  ["tag", "string"],
  ["description", "string"],
];

export const tagsReqFields = mapFieldArrToObjSchema(tagsForm);
